// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';
import { type IncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';
import { type Card, getTokenizationFunction, formatExpiryDate } from '@tectonics/prs/card';
import { detectCardBrand } from '@tectonics/prs/card-brand';
import { type OutgoingPaymentTokenizedCard } from '@tectonics/prs/card/tokenized';

export async function creditCardOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
): Promise<$Shape<OutgoingPayment>> {
  if (isOneClickCardType(userInputValues)) {
    return oneClickOutgoingPaymentMapper(userInputValues);
  }

  const brand = detectCardBrand(userInputValues['cardNumber']) || '';

  const card: Card = {
    brand: brand || '',
    holderName: userInputValues['cardHolderName'],
    cardNumber: userInputValues['cardNumber'],
    expiryDate: formatExpiryDate(userInputValues['cardExpiryDate']),
    securityCode: userInputValues['cardSecurityCode'],
  };

  const merchant = getMerchant(incomingPayment);
  const country = getCountry(incomingPayment);
  const publicIntegrationKey = getPublicIntegrationKey(merchant);

  const tokenizedCard: OutgoingPaymentTokenizedCard = await getTokenizationFunction(incomingPayment)({
    card,
    country,
    publicIntegrationKey,
    paymentTypeCode: 'creditcard',
  });

  return {
    card: { ...tokenizedCard, card_cvv: card.securityCode },
    payment_type: 'creditcard',
    payment_type_code: tokenizedCard.payment_type_code,
  };
}

function isOneClickCardType(userInputValues: UserInputValues): boolean {
  return userInputValues['selectedCardType'] === 'oneclick';
}

export async function oneClickOutgoingPaymentMapper(
  userInputValues: UserInputValues,
): Promise<$Shape<OutgoingPayment>> {

  return {
    card: { card_cvv: userInputValues['cardSecurityCode'] },
    payment_type: 'oneclick',
    payment_type_code: 'oneclick',
  };
}
